import state from "./moduleNotificationState";
import mutations from "./moduleNotificationMutations";
import actions from "./moduleNotificationActions";
import getters from "./moduleNotificationGetters";

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}